const language = {
  en: {
    search: "Search",
    gptSearchPlaceholder: "What do you like to watch Today ?",
    guideTitle: "How GPT Search Works 🚀",
    guideStep1Title: "1. Ask the AI",
    guideStep1Desc: "Describe what you want to watch (e.g. 'retro horror' or 'funny rom-com').",
    guideStep2Title: "2. Get Suggestions",
    guideStep2Desc: "Our OpenAI-powered search generates a handpicked list of 5 movies.",
    guideStep3Title: "3. Fetch Details",
    guideStep3Desc: "We retrieve posters, descriptions, and trailers directly from TMDB.",
    suggestionTitle: "Or try these quick search suggestions:",
    suggestions: [
      "Mind-bending sci-fi thrillers",
      "Retro horror movies from the 80s",
      "Feel-good romantic comedies",
      "Action-packed superhero movies",
      "Hidden gems and underrated masterpieces",
    ],
  },
  hindi: {
    search: "खोज",
    gptSearchPlaceholder: "आज आप क्या देखना पसंद करते हैं?",
    guideTitle: "जीपीटी खोज कैसे काम करती है 🚀",
    guideStep1Title: "1. एआई से पूछें",
    guideStep1Desc: "वर्णन करें कि आप क्या देखना चाहते हैं (जैसे, 'रेट्रो हॉरर' या 'मज़ेदार रॉम-कॉम')।",
    guideStep2Title: "2. सुझाव प्राप्त करें",
    guideStep2Desc: "हमारा OpenAI-संचालित खोज 5 फिल्मों की एक चुनिंदा सूची तैयार करता है।",
    guideStep3Title: "3. विवरण प्राप्त करें",
    guideStep3Desc: "हम सीधे TMDB से पोस्टर, विवरण और ट्रेलर प्राप्त करते हैं।",
    suggestionTitle: "या इन त्वरित खोज सुझावों को आजमाएं:",
    suggestions: [
      "दिमाग को घुमा देने वाली साइंस-फिक्शन थ्रिलर",
      "80 के दशक की रेट्रो हॉरर फिल्में",
      "दिल को छू लेने वाली रोमांटिक कॉमेडी",
      "एक्शन से भरपूर सुपरहीरो फिल्में",
      "छिपे हुए रत्न और कम आंकी गई फिल्में",
    ],
  },
  telugu: {
    search: "వెతకండి ",
    gptSearchPlaceholder: "మీరు ఈరోజు ఏమి చూడాలనుకుంటున్నారు?",
    guideTitle: "GPT శోధన ఎలా పనిచేస్తుంది 🚀",
    guideStep1Title: "1. AI ని అడగండి",
    guideStep1Desc: "మీరు ఏమి చూడాలనుకుంటున్నారో వివరించండి (ఉదా. 'రెట్రో హారర్' లేదా 'ఫన్నీ రోమ్-కామ్').",
    guideStep2Title: "2. సిఫార్సులు పొందండి",
    guideStep2Desc: "మా OpenAI-శోధన మీ కోసం 5 ఉత్తమ సినిమాల జాబితాను రూపొందిస్తుంది.",
    guideStep3Title: "3. వివరాలను చూడండి",
    guideStep3Desc: "మేము TMDB నుండి పోస్టర్లు, వివరాలు మరియు ట్రైలర్లను నేరుగా పొందుతాము.",
    suggestionTitle: "లేదా ఈ శీఘ్ర శోధన సూచనలను ప్రయత్నించండి:",
    suggestions: [
      "మైండ్ బెండింగ్ సైన్స్ ఫిక్షన్ థ్రిల్లర్స్",
      "80ల నాటి రెట్రో హారర్ సినిమాలు",
      "ఫీల్ గుడ్ రొమాంటిక్ కామెడీలు",
      "యాక్షన్ ప్యాక్డ్ సూపర్ హీరో సినిమాలు",
      "అండర్ రేటెड క్లాసిక్ సినిమాలు",
    ],
  },
  spanish: {
    search: "Buscar",
    gptSearchPlaceholder: "¿Qué te gusta ver hoy?",
    guideTitle: "Cómo funciona la búsqueda GPT 🚀",
    guideStep1Title: "1. Pregúntale a la IA",
    guideStep1Desc: "Describe lo que quieres ver (ej. 'terror retro' o 'comedia romántica divertida').",
    guideStep2Title: "2. Obtén sugerencias",
    guideStep2Desc: "Nuestra búsqueda con OpenAI genera una lista selecta de 5 películas.",
    guideStep3Title: "3. Obtén detalles",
    guideStep3Desc: "Recuperamos pósters, descripciones y avances directamente de TMDB.",
    suggestionTitle: "O prueba con estas sugerencias rápidas:",
    suggestions: [
      "Thrillers de ciencia ficción alucinantes",
      "Películas de terror retro de los 80",
      "Comedias románticas reconfortantes",
      "Películas de superhéroes llenas de acción",
      "Joyas ocultas y obras maestras subestimadas",
    ],
  },
  german: {
    search: "Suchen",
    gptSearchPlaceholder: "Was sehen Sie heute gerne?",
    guideTitle: "Wie die GPT-Suche funktioniert 🚀",
    guideStep1Title: "1. Fragen Sie die KI",
    guideStep1Desc: "Beschreiben Sie, was Sie sehen möchten (z.B. 'Retro-Horror' oder 'lustige Rom-Com').",
    guideStep2Title: "2. Vorschläge erhalten",
    guideStep2Desc: "Unsere OpenAI-gestützte Suche erstellt eine Auswahlliste von 5 Filmen.",
    guideStep3Title: "3. Details abrufen",
    guideStep3Desc: "Wir laden Poster, Beschreibungen und Trailer direkt von TMDB.",
    suggestionTitle: "Oder probieren Sie diese Schnellvorschläge aus:",
    suggestions: [
      "Fesselnde Science-Fiction-Thriller",
      "Retro-Horrorfilme aus den 80ern",
      "Herzerwärmende romantische Komödien",
      "Actiongeladene Superheldenfilme",
      "Geheimtipps und unterschätzte Meisterwerke",
    ],
  },
};

export default language;
